import * as React from 'react'
import { useParams } from 'react-router-dom';
import { AsyncButton, DropDownButton, ToggleFilter } from 'uxp/components';
import { IDefaultUIProps } from '../..';
import { extractModuleIdFromURLAndLoadScript, findCardTemplate } from '../common/common';
import Designer, { IDesignerInstanceProps, IDesignerMode } from './Designer';
import Layout from './Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WidgetDesignerThemeChanger from './WidgetDesignerThemeChanger';

interface ICreateWidgetProps extends IDefaultUIProps {
    modelKey: string;
    initialSource: string;
}

const CreateWidget: React.FunctionComponent<ICreateWidgetProps> = props => {
    const { uxpContext } = props

    let { template } = useParams<{ template: string }>()
    const [mode, setMode] = React.useState<IDesignerMode>('design')
    const [canSave, setCanSave] = React.useState(false)
    const [hasModified, setHasModified] = React.useState(false)
    let [closePopup, setClosePopup] = React.useState(false)

    // just to force render
    const [counter, setCounter] = React.useState(0)


    React.useEffect(() => {
        extractModuleIdFromURLAndLoadScript()
            .then(res => {
                setCounter(prev => prev + 1)
            })
    }, [template, window.location])


    const designerRef: React.MutableRefObject<IDesignerInstanceProps> = React.useRef(null)

    const headerActions = () => {

        return <>

           <WidgetDesignerThemeChanger />

            <ToggleFilter
                value={mode as string}
                onChange={s => setMode(s as IDesignerMode)}
                options={[
                    { label: 'Design', value: 'design' },
                    { label: 'Preview', value: 'preview' }
                ]}
                className="lucy-canvas-toggle-button"
            />

            <AsyncButton
                title='Save Widget'
                loadingTitle='Saving Widget...'
                icon='fas save'
                onClick={designerRef.current?.save}
                className='uxp-designer-action-btn save-btn'
                active={canSave}
            />

            <DropDownButton
                content={() => <>

                    <div className="uxp-designer-advanced-action-dropdown-content">
                        <div className="uxp-designer-advanced-action-dropdown-content-section">

                            <div className="uxp-designer-advanced-action-dropdown-content-section-title">Save widget as a Template</div>
                            <div className="uxp-designer-advanced-action-dropdown-content-section-description">This will save the widget as a new Template under "My Templates" and you will be able to use this later as a template to create new widgets</div>
                            <AsyncButton
                                title='Save widget as a template'
                                loadingTitle='Saving...'
                                onClick={() => designerRef.current?.saveAsTemplate().then(res => setClosePopup(true))}
                                active={canSave}
                            />

                        </div>
                    </div>
                </>}
                onClose={() => { setClosePopup(false) }}
                forceClose={closePopup}
            >
                <div className="uxp-designer-advanced-action-dropdown-btn">
                    <FontAwesomeIcon icon={['fas', 'ellipsis-h']} />
                </div>
            </DropDownButton>
        </>
    }

    return <Layout
        uxpContext={uxpContext}
        headerActions={headerActions}
        hasModified={hasModified}
    >

        <Designer
            isMobile={false}
            ref={designerRef}
            mode={mode}
            modelKey={props.modelKey}
            initialSource={props.initialSource}
            onChangeMode={setMode}
            isNew={true}
            template={findCardTemplate(template)}
            uxpContext={uxpContext}
            enableSave={(val) => { setCanSave(val) }}
            onModifiyContent={(val) => {
                setHasModified(val)
                setCounter(prev => (prev += 1))
            }}
            templateId={template}
        />

    </Layout>
}

export default CreateWidget